// extracted by mini-css-extract-plugin
module.exports = {"MenuActivation":"MenuActivation_MenuActivation__INTwj","pulse":"MenuActivation_pulse__6vKG8"};